import { render, staticRenderFns } from "./index.vue?vue&type=template&id=079b3fb4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=079b3fb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b3fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079b3fb4')) {
      api.createRecord('079b3fb4', component.options)
    } else {
      api.reload('079b3fb4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=079b3fb4&scoped=true", function () {
      api.rerender('079b3fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/classify/index.vue"
export default component.exports